export default (props) => {
  const params = new URLSearchParams(props.history.location.search);
  const selection = {};

  params.forEach((value, name) => {
    const key = name.match(/(.+)\[]/)?.[1];

    if (!key) return;

    const values = selection[key] || [];
    const valueAsNumber = Number(value);

    selection[key] = [...values, Number.isNaN(valueAsNumber) ? value : valueAsNumber];
  });

  return selection;
};
